import { Injectable } from '@angular/core';
import { BurialLayoutType } from '../enums/burial-layout-type';
import { ElementAttribute } from '../enums/element-attribute';
import { Subscription, fromEvent, map, merge, of } from 'rxjs';
import { BroadcastService } from './broadcast.service';
import { BroadcastEvents } from '../enums/broadcast-events';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {

  burialLayoutType: BurialLayoutType = BurialLayoutType.burials;
  importContractID?: number;
  userImage?: string;
  userName?: string;
  userRole?: number;
  userID?: number;
  humanID?: number;
  humanName?: string;
  fullName?: string;
  fullLastName?: string;
  isApplicationOnline: boolean = navigator.onLine;
  isRunningInElectron: boolean = navigator.userAgent.toLowerCase().includes('electron');

  private currentNetworkState$: Subscription = Subscription.EMPTY;

  constructor(private broadcastService: BroadcastService) {
    this.startCheckingNetworkState()
  }

  ngOnDestroy(): void {
    this.currentNetworkState$.unsubscribe();
  }

  private startCheckingNetworkState() {
    this.isApplicationOnline = navigator.onLine;
    this.currentNetworkState$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    ).pipe(map(() => navigator.onLine))
      .subscribe(newNetworkState => {
        if (this.isApplicationOnline == newNetworkState) { return; }
        this.isApplicationOnline = newNetworkState;
        this.broadcastService.dispatch(BroadcastEvents.networkStateChanged);
      });
  }

  setBlockedDates(newValue: any) {
    localStorage.setItem('blockedDates', JSON.stringify(newValue));
  }

  getBlockedDatesByType(): any {
    return [];
  }

  changeActiveUser(userObject?: any) {
    if (!userObject) {
      userObject = {};

      const userImage = localStorage.getItem('userImage');
      if (userImage) {
        userObject.userImage = userImage;
      }

      const userName = localStorage.getItem('userName');
      if (userName) {
        userObject.userName = userName;
      }

      const userRole = localStorage.getItem('userRole');
      if (userRole) {
        userObject.userRole = userRole;
      }

      const userID = localStorage.getItem('userID');
      if (userID) {
        userObject.userID = userID;
      }

      const humanID = localStorage.getItem('humanID');
      if (humanID) {
        userObject.humanID = humanID;
      }

      const humanName = localStorage.getItem('humanName');
      if (humanName) {
        userObject.humanName = humanName;
      }
    }

    if (userObject.userImage) {
      this.userImage = userObject.userImage;
      localStorage.setItem('userImage', userObject.userImage);
    }

    if (userObject.userName) {
      this.userName = userObject.userName;
      localStorage.setItem('userName', userObject.userName);
    }

    if (userObject.userRole) {
      this.userRole = userObject.userRole;
      localStorage.setItem('userRole', userObject.userRole);
    }

    if (userObject.userID) {
      this.userID = userObject.userID;
      localStorage.setItem('userID', userObject.userID);
    }

    if (userObject.humanID) {
      this.humanID = userObject.humanID;
      localStorage.setItem('humanID', userObject.humanID);
    }

    if (userObject.humanName) {
      this.humanName = userObject.humanName;
      localStorage.setItem('humanName', userObject.humanName);
    }
  }

  checkAuthentication(): boolean {
    if (localStorage.getItem('sessionID') && localStorage.getItem('sessionToken')) {
      return true;
    }
    return false;
  }

  checkDateLogic(checkDate: string): boolean {
    if (checkDate && checkDate.length == 10) { return true; }
    return false;
  }

  checkTimeLogic(checkTime: string): boolean {
    if (checkTime && checkTime.length == 5) { return true; }
    return false;
  }

  userCredentials(userCredentials?: any): any {
    if (!userCredentials) {
      const sessionID = localStorage.getItem('sessionID');
      const sessionToken = localStorage.getItem('sessionToken');
      const sessionUser = localStorage.getItem('sessionUser');

      if (sessionID && sessionToken) {
        return {
          sessionID: sessionID,
          sessionToken: sessionToken,
          sessionUser: sessionUser
        };
      }

      return null;
    }

    if (userCredentials.sessionID) {
      localStorage.setItem('sessionID', userCredentials.sessionID);
    }

    if (userCredentials.sessionToken) {
      localStorage.setItem('sessionToken', userCredentials.sessionToken);
    }

    if (userCredentials.sessionUser) {
      localStorage.setItem('sessionUser', userCredentials.sessionUser);
    }
  }

  parseElementBy(elementAttribute: ElementAttribute, value: string): any {
    var returnElement: any = null;

    switch (elementAttribute) {
      case ElementAttribute.id:
        returnElement = document.getElementById(value);
        break;
      case ElementAttribute.class:
        // First try to find by ID if the value matches an ID pattern
        const elementById = document.getElementById(value);
        if (elementById && elementById.classList.contains(value)) {
          returnElement = elementById;
        } else {
          // Fallback to original class search logic
          const elements = document.getElementsByClassName(value);
          for (let index = 0; index < elements.length; index++) {
            const element = elements[index];

            element.classList.forEach(className => {
              if (className == value) {
                returnElement = element;
              }
            });
          }
        }
        break;
    }

    return returnElement;
  }

  isIEBrowser(): boolean {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      return true;
    }
    return false;
  }

}
